import * as yup from 'yup';
import { t } from "@lang/i18n";

/* Auth */
export const registerCompanySchema = yup.object().shape({  
    name: yup.string().required(t('messages.validation.register.company.name')),
    address: yup.string().required(t('messages.validation.register.company.address')),
    siret: yup.string().required(t('messages.validation.register.company.siret')),
    activities: yup.object().shape( { value: yup.string(), label: yup.string() } ).required(t('messages.validation.register.company.activities')).nullable(),
    email: yup.string().email(t('messages.validation.register.company.email.err_1')).required(t('messages.validation.register.company.email.err_2')),
    password: yup.string().min(8, t('messages.validation.register.company.password.err_1')).required(t('messages.validation.register.company.password.err_2')),
    fonctions: yup.array().min(1, t('messages.validation.register.company.fonctions')).required(t('messages.validation.register.company.fonctions')).nullable(),
    isChecked: yup.boolean().oneOf([true], t('messages.validation.register.company.isChecked'))
});

export const registerCandidateSchema = yup.object().shape({  
    first_name: yup.string().required(t('messages.validation.register.candidate.first_name')),
    last_name: yup.string().required(t('messages.validation.register.candidate.last_name')),
    email: yup.string().email(t('messages.validation.register.candidate.email.err_1')).required(t('messages.validation.register.candidate.email.err_2')),
    password: yup.string().min(8, t('messages.validation.register.candidate.password.err_1')).required(t('messages.validation.register.candidate.password.err_2')),
    phone: yup.string().length(10, t('messages.validation.register.candidate.phone.err_1')).required(t('messages.validation.register.candidate.phone.err_2')),
    isChecked: yup.boolean().oneOf([true], t('messages.validation.register.candidate.isChecked'))
});

export const loginSchema = yup.object().shape({
    email: yup.string().email(t('messages.validation.login.email.err_1')).required(t('messages.validation.login.email.err_2')),
    password: yup.string().required(t('messages.validation.login.password.err_2')),
});

export const forgotPasswordSchema = yup.object().shape({
    email: yup.string().email(t('messages.validation.forgot.err_1')).required(t('messages.validation.forgot.err_2'))
});

/* Profile */
export const resetPasswordSchema = yup.object().shape({
    new_password: yup.string()
                    .min(8, t('messages.validation.reset.new_password.err_2'))
                    .required(t('messages.validation.reset.new_password.err_1')),                    
    password: yup.string()
                    .required(t('messages.validation.reset.password.err_1'))                   
}); 

export const editProfileCompanySchema = yup.object().shape({
  description: yup.string().nullable(),
  size: yup.number().positive().integer().nullable(),
  founded_in: yup.number().positive().integer().nullable(),
  website: yup.string().nullable(),
  phone: yup.number().positive().integer().nullable(),
  fonctions: yup.array()
                .min(1, t('messages.validation.edit.company.fonctions')),
  activities: yup.array()
                  .min(1, t('messages.validation.edit.company.activities'))
                  .required(t('messages.validation.edit.company.activities')),
  siret: yup.string()
              .required(t('messages.validation.edit.company.siret')),
  address: yup.string()
              .required(t('messages.validation.edit.company.address')),
  email: yup.string().email(t('messages.validation.edit.company.email.err_1')).required(t('messages.validation.edit.company.email.err_2')),
  name: yup.string()
              .required(t('messages.validation.edit.company.name')),
},
);

export const editProfileCandidateSchema = yup.object().shape({
  preferred_contracts: yup.array().min(1, t('messages.validation.edit.candidate.preferred_contract')),
  driving_license: yup.boolean(),
  has_vehicle: yup.boolean(),
  has_handicap: yup.boolean(),
  relationship_status: yup.string(),
  experience: yup.string().required('Champs obligatoire'),
  activities: yup.array()
                  .min(1, t('messages.validation.edit.candidate.activities'))
                  .required(t('messages.validation.edit.candidate.activities')).nullable(),
  fonctions: yup.array().min(1, t('messages.validation.edit.candidate.fonctions'))
                  .required(t('messages.validation.edit.candidate.activities')).nullable(),
  situation: yup.string(),
  search_radius: yup.string(),
  birthday: yup.string(),
  address: yup.string()
                  .required(t('messages.validation.edit.candidate.address')),
  email: yup.string()
                  .email(t('messages.validation.edit.candidate.email.err_1'))
                  .required(t('messages.validation.edit.candidate.email.err_2')),
  phone: yup.string()
                  .required(t('messages.validation.edit.candidate.phone')),
  last_name: yup.string()
                  .required(t('messages.validation.edit.candidate.last_name')),
  first_name: yup.string()
                  .required(t('messages.validation.edit.candidate.first_name')),
});

/* Annonce */
export const annonceSchema = yup.object().shape({
  nbr_positions: yup.number()
                      .positive(t('messages.validation.annonce.nbr_positions.err_2'))
                      .typeError(t('messages.validation.annonce.nbr_positions.err_1'))
                      .required(t('messages.validation.annonce.nbr_positions.err_1')),
  address: yup.string().required(t('messages.validation.annonce.address')),
  experience: yup.array()
                  .min(1, t('messages.validation.annonce.experience')).required(t('messages.validation.annonce.experience')).nullable(),
  contracts: yup.array()
                  .min(1, t('messages.validation.annonce.contract')).required(t('messages.validation.annonce.contract')).nullable(),
  fonctions: yup.array()
                  .min(1, t('messages.validation.annonce.fonctions')).required(t('messages.validation.annonce.fonctions')).nullable(),
  salary_min: yup.string().required(t('messages.validation.annonce.salary_min')),                    
  salary_max: yup.string().required(t('messages.validation.annonce.salary_max')),  
  description: yup.string().required(t('messages.validation.annonce.description'))            
}); 